import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-newField-ckeditor-admin-config',
  templateUrl: './newField-ckeditor-admin-config.component.html',
  styleUrls: ['./newField-ckeditor-admin-config.component.scss']
})
export class AtwNewFieldCkeditorAdminConfig  extends AtwUpdateDbComponent  implements OnInit {

  @Input() objectChoosing: any;
  @Input() class: any;
  @Input() device: any; 
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  newFieldCKEditors: any;
  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator:VhEventMediator,
    public functionService: FunctionService,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit() {
    this.getNewFieldCkeditor();
  }

  getNewFieldCkeditor() {
   this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.staticdata.id_main_sector }, field_typeof: { $eq: `string` }, display_type: { $eq: `ckeditor` } })
     .then((newfields: any) => { 
       this.newFieldCKEditors = newfields;
     });
  }

  

  updateTypeDisplay(){ 
    if(this.class['text']['overflow-y']=='visible') this.class['text']['height']='100%'
    else this.class['text']['height']= `${this.config?.dimension?.height}px` || '100%'
    this.updateClass()
  }

  // /**
  // *Hàm update class vào database.
  // */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }
  
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text']['width'] = event.width + 'px';
    if (event.height) this.class['text']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  // }

}
